import { FileText, Loader2, Trash2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { ProductDrawingFile } from '@/shared/hooks/api/rohsProductDrawings'
import { Button } from '@/components/ui/button'
import {
  Attachment,
  AttachmentActions,
  AttachmentContent,
  AttachmentDescription,
  AttachmentMedia,
  AttachmentTitle,
} from '@/components/ui/attachment'

type ProductDrawingListItemProps = {
  file: ProductDrawingFile
  isUploading?: boolean
  deleteDisabled?: boolean
  onDelete: () => Promise<void>
}

export function ProductDrawingListItem({
  file,
  isUploading = false,
  deleteDisabled = false,
  onDelete,
}: ProductDrawingListItemProps) {
  const { t } = useTranslation('common')

  return (
    <Attachment state={isUploading ? 'uploading' : 'done'} size="sm" className="w-full">
      <AttachmentMedia>
        {isUploading ? (
          <Loader2 className="animate-spin" aria-hidden />
        ) : (
          <FileText aria-hidden />
        )}
      </AttachmentMedia>
      <AttachmentContent>
        <AttachmentTitle title={file.fileName}>{file.fileName}</AttachmentTitle>
        <AttachmentDescription>
          {isUploading
            ? t('v2.pages.products.detail.drawings.uploading')
            : t('v2.pages.products.detail.drawings.uploaded')}
        </AttachmentDescription>
      </AttachmentContent>
      <AttachmentActions>
        <Button
          type="button"
          variant="ghost"
          size="icon-sm"
          disabled={deleteDisabled || isUploading}
          aria-label={t('v2.pages.products.detail.drawings.deleteFile', {
            fileName: file.fileName,
          })}
          onClick={() => {
            void onDelete()
          }}
        >
          <Trash2 className="size-4" />
        </Button>
      </AttachmentActions>
    </Attachment>
  )
}
